import React from "react";
import { DisabledInput, Edit, SimpleForm, TextInput } from "react-admin";
import { getJwtData } from "./../providers";
import { UserEditActions } from "./../actions/UserEdit";
import { ToolbarSave } from "./toolbarSave";

const UserNameEdit = ({ title }) => {
  return <span>{title}</span>;
};

export class UserProfileEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {}
    };
  }

  componentDidMount() {
    const jwt = getJwtData();
    const user = { _id: jwt.usuariosId, _rol: jwt.role };
    this.setState({ user });
  }

  renderFormTitle(permissions) {
    const titles = {
      admin: () => "Modificar Detalles",
      coordinador: () => "Modificar Contraseña",
      cartonero: () => "Modificar Contraseña",
      pesador: () => "Modificar Contraseña"
    };
    const title = titles[permissions]();
    return <UserNameEdit title={title} />;
  }

  renderForm() {
    const { user } = this.state;
    const permissions = user._rol;
    const forms = {
      admin: () => this.renderAdminForm(),
      cartonero: () => this.renderCartoneroForm(),
      coordinador: () => this.renderCoordinadorForm(),
      pesador: () => this.renderPesadorForm()
    };
    const userForm = forms[permissions]();
    return (
      <Edit
        actions={<UserEditActions />}
        title={this.renderFormTitle(permissions)}
        permissions={user._rol}
        {...this.props}
        id={user._id}
      >
        {userForm}
      </Edit>
    );
  }

  renderAdminForm() {
    return (
      <SimpleForm toolbar={<ToolbarSave {...this.props} />}>
        <TextInput label="Nombre y Apellido" source="nombre" />
        <DisabledInput label="D.N.I." source="dni" />
        <TextInput label="Contraseña" source="validacion" type="password" />
      </SimpleForm>
    );
  }

  renderCartoneroForm() {
    return (
      <SimpleForm toolbar={<ToolbarSave {...this.props} />}>
        <DisabledInput label="Nombre y Apellido" source="nombre" />
        <DisabledInput label="Etapa" source="etapa" />
        <DisabledInput label="D.N.I." source="dni" />
        <DisabledInput label="Bolsón" source="bolson" />
        <TextInput label="Contraseña" source="validacion" type="password" />
      </SimpleForm>
    );
  }

  renderCoordinadorForm() {
    return (
      <SimpleForm toolbar={<ToolbarSave {...this.props} />}>
        <DisabledInput label="Nombre y Apellido" source="nombre" />
        <DisabledInput label="Etapa" source="etapa" />
        <DisabledInput label="D.N.I." source="dni" />
        <TextInput label="Contraseña" source="validacion" type="password" />
      </SimpleForm>
    );
  }

  renderPesadorForm() {
    return (
      <SimpleForm toolbar={<ToolbarSave {...this.props} />}>
        <DisabledInput label="Nombre y Apellido" source="nombre" />
        <DisabledInput label="D.N.I" source="dni" />
        <TextInput label="Contraseña" source="validacion" type="password" />
      </SimpleForm>
    );
  }

  render() {
    if (this.state.user && this.state.user._id) {
      return this.renderForm();
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/UserProfileEdit.js